<template>
  <div
    class="filter-container"
    @click="handleCloseFilters"
    :class="{ open: active }"
  >
    <div class="content" :class="{ open: active }">
      <div class="item">
        <h2>服务项目<span class="tips">(多选)</span></h2>
        <ul class="tags" @click="handleClickServicePlace">
          <li
            v-for="(servicePlace, index) in servicePlaces"
            :key="index"
            :class="{ active: selectedServicePlaces.includes(servicePlace) }"
          >
            {{ servicePlace }}
          </li>
        </ul>
      </div>
      <div class="item">
        <h2>职业<span class="tips">(多选)</span></h2>
        <ul class="tags" @click="handleClickNationality">
          <li
            v-for="(nationality, index) in nationalities"
            :key="index"
            :class="{ active: selectedNationalities.includes(nationality) }"
          >
            {{ nationality }}
          </li>
        </ul>
      </div>
      <div class="item">
        <h2>年龄区间<span class="tips">(填写)</span></h2>
        <div class="inputs">
          <p class="input-container">
            <input type="number" placeholder="最小年龄" v-model="minAge" />
          </p>
          <span class="line"></span>
          <p class="input-container">
            <input type="number" placeholder="最大年龄" v-model="maxAge" />
          </p>
        </div>
      </div>
      <div class="item">
        <h2>胸围<span class="tips">(填写)</span></h2>
        <div class="inputs">
          <p class="input-container">
            <input type="text" placeholder="填写胸围" v-model="bust" />
          </p>
        </div>
      </div>
      <div class="item">
        <h2>身高<span class="tips">(填写)</span></h2>
        <div class="inputs">
          <p class="input-container">
            <input type="number" placeholder="最小身高" v-model="minHeight" />
            <span class="height-unit">CM</span>
          </p>
          <span class="line"></span>
          <p class="input-container">
            <input type="number" placeholder="最大身高" v-model="maxHeight" />
            <span class="height-unit">CM</span>
          </p>
        </div>
      </div>
      <div class="footer">
        <div class="reset" @click="handleResetForm">重置</div>
        <div class="submit" @click="handleSubmit">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Filters",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    servicePlaces: {
      type: Array,
      default: () => []
    },
    nationalities: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    active(newVal) {
      if (newVal === true) {
        this.scrollTop = document.scrollingElement.scrollTo;
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }
  },
  data() {
    return {
      selectedServicePlaces: [],
      selectedNationalities: [],
      minAge: null,
      maxAge: null,
      minHeight: null,
      maxHeight: null,
      bust: null,
      scrollTop: 0
    };
  },
  methods: {
    handleClickServicePlace(event) {
      if (event.target.nodeName === "LI") {
        const selectedSingle = event.target.innerHTML.trim();
        const selectedArray = [...this.selectedServicePlaces];
        if (selectedArray.includes(selectedSingle)) {
          selectedArray.splice(selectedArray.indexOf(selectedSingle), 1);
        } else {
          selectedArray.push(selectedSingle);
        }
        this.selectedServicePlaces = selectedArray;
      }
    },
    handleClickNationality(event) {
      if (event.target.nodeName === "LI") {
        const selectedSingle = event.target.innerHTML.trim();
        const selectedArray = [...this.selectedNationalities];
        if (selectedArray.includes(selectedSingle)) {
          selectedArray.splice(selectedArray.indexOf(selectedSingle), 1);
        } else {
          selectedArray.push(selectedSingle);
        }
        this.selectedNationalities = selectedArray;
      }
    },
    handleResetForm() {
      this.selectedServicePlaces = [];
      this.selectedNationalities = [];
      this.minAge = null;
      this.maxAge = null;
      this.minHeight = null;
      this.maxHeight = null;
      this.bust = null;
    },
    handleSubmit() {
      this.$emit("filter-submit", {
        selectedServicePlaces: this.selectedServicePlaces,
        selectedNationalities: this.selectedNationalities,
        minAge: this.minAge,
        maxAge: this.maxAge,
        minHeight: this.minHeight,
        maxHeight: this.maxHeight,
        bust: this.bust
      });
      this.$emit("update:active", false);
    },
    handleCloseFilters(event) {
      if (event.target.className === "filter-container open") {
        this.$emit("update:active", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 999;
  transition: all 1s ease 0s;
  visibility: hidden;
  .content {
    overflow: scroll;
    display: flex;
    flex-direction: column;
    margin-left: 10%;
    padding: 13px 0 100px 0;
    width: 90%;
    background: #fff;
    height: 100%;
    text-align: left;
    transition: transform 1s ease 0s;
    transform: translateX(100%);
    .item {
      margin-left: 5px;
      h2 {
        margin: 0 0 20px 15px;
        font-size: 15px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        .tips {
          display: inline-block;
          margin-left: 10px;
          font-size: 14px;
          color: #999999;
        }
      }
      .tags {
        display: flex;
        flex-wrap: wrap;
        li {
          margin: 0 10px 15px 10px;
          width: 90px;
          height: 32px;
          line-height: 32px;
          border-radius: 16px;
          border: 1px solid rgba(246, 246, 246, 1);
          background: rgba(246, 246, 246, 1);
          font-size: 13px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          text-align: center;
          transition: all 0.5s ease 0s;
        }
        .active {
          border: 1px solid rgba(228, 191, 88, 1);
          background: #fff;
          color: rgba(228, 191, 88, 1);
        }
      }
      .inputs {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;
        margin-left: 10px;
        .input-container {
          overflow: hidden;
          width: 140px;
          height: 32px;
          border-radius: 16px;
          background: rgba(246, 246, 246, 1);
          text-align: center;
          input {
            border: none;
            outline: none;
            width: 50%;
            height: 100%;
            background: transparent;
            text-align: center;
            font-size: 13px;
            color: #333333;
          }
          .height-unit {
            font-size: 13px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
        .line {
          margin: 0 11px;
          width: 8px;
          height: 1px;
          background: rgba(132, 132, 132, 1);
        }
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      padding: 30px 0;
      div {
        width: 130px;
        height: 46px;
        line-height: 46px;
        font-size: 15px;
        text-align: center;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        border-radius: 28px;
      }
      .reset {
        margin-right: 30px;
        background: #fff;
        border: 1px solid rgba(230, 230, 230, 1);
      }
      .submit {
        background: rgba(253, 215, 0, 1);
        border: none;
      }
    }
  }
  .open {
    transform: translateX(0);
  }
}
.open {
  background: rgba(0, 0, 0, 0.5);
  visibility: visible;
}
</style>
